import Filters from './Filters';
import Search from './Search';
import * as Styles from './styles';

const Discovery = () => {
  return (
    <Styles.Wrapper>
      <Search />
      <Filters />
    </Styles.Wrapper>
  );
};

export default Discovery;
